<div *ngIf="isReady">
    <div class="mb-3 p-3 rounded border bg-white shadow-sm">
        <div [formGroup]="assistantForm" *ngIf="assistantForm">

            <h5 class="mb-3">Assistant / Contact Person</h5>

            <div class="row">
                <div class="col-6 pb-2">
                    <div id="investor-register-asisstant-field-name-text" class="pb-1">Name</div>
                    <input 
                        id="investor-register-asisstant-field-name-input" 
                        type="text" class="form-control"
                        formControlName="assistantFirstName" 
                        autocomplete="new-assistantFirstName"
                        normalizeName>
                </div>
                
                <div class="col-6 pb-2">
                    <div id="investor-register-asisstant-field-surname-text" class="pb-1">Surname</div>
                    <input 
                        id="investor-register-asisstant-field-surname-input" 
                        type="text" 
                        class="form-control" 
                        formControlName="assistantLastName" 
                        autocomplete="new-assistantLastName"
                        normalizeName>
                </div>
                
                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-asisstant-field-email-text" class="pb-1">Email</div>
                    <input 
                        id="investor-register-asisstant-field-email-input" 
                        type="email"
                        class="form-control" 
                        formControlName="assistantEmail" 
                        placeholder="example@xxx.or.th"
                        englishInput>
                    <small id="investor-register-assistant-field-email-duplicated-error-text" *ngIf="f.assistantEmail.errors?.duplicateEmail" class="text-danger">
                        Attendee and Assistant email must not be the same
                    </small>
                    <small id="investor-register-asisstant-field-email-already-used-error-text" *ngIf="f.assistantEmail.errors?.alreadyUsed" class="text-danger">
                        Email is already registered
                    </small>
                    <p class="invalid-input" *ngIf="f.assistantEmail.touched && f.assistantEmail.invalid">
                    <small id="investor-register-asisstant-field-email-pattern-error-text" *ngIf="f.assistantEmail.errors?.email" class="text-danger">
                        Please provide a valid email address
                    </small>
                    </p>
                </div>

                <div class="col-3 pb-2 mt-2">
                    <div id="investor-register-asisstant-field-mobile-text" class="pb-1">Mobile Number</div>
                    <ngx-intl-tel-input 
                        [cssClass]="'form-control intl-tel-input'" 
                        [preferredCountries]="preferredCountries"
                        [searchCountryFlag]="true"
                        [searchCountryField]="searchCountryField"
                        [phoneValidation]="true" 
                        [inputId]="'investor-register-asisstant-field-mobile-input'" 
                        formControlName="assistantMobileNumber" 
                        [enablePlaceholder]="true"
                        mobile>
                    </ngx-intl-tel-input>
                    <small id="investor-register-asisstant-field-mobile-pattern-error-text" class="text-danger" *ngIf="f.assistantMobileNumber.errors?.validatePhoneNumber">Mobile is invalid pattern.</small>
                </div>

                <div class="col-3 pb-2 mt-2">
                    <div id="investor-register-asisstant-field-ext-number-text" class="pb-1">Ext. Number</div>
                    <input 
                        id="investor-register-asisstant-field-ext-number-input" 
                        type="text" 
                        class="form-control" 
                        formControlName="assistantExtNumber" 
                        englishInput>
                </div>
            </div>
        </div>
    </div>
</div>